import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Server } from '.'

export const serverSettingsQuery = gql`
  query ServerSettings($organizationID: String!, $serverID: String!) {
    server(organizationID: $organizationID, serverID: $serverID) {
      id
      name
      logPath
      environment
      logLevel
      botProtection
      stacktraceCaptureMode
      assess
      protect
      language
      syslogConfig {
        enabled
        ipAddress
        port
        facilityCode
        protocol
        severityExploited
        severitySuspicious
        severityBlocked
        severityBlockedPerimeter
        severityProbed
      }
      samplingProfile
      sampling {
        enabled
        frequency
        baseline
        window
      }
    }
  }
`

interface ChildrenProps {
  readonly loading: boolean
  readonly server: Server
  readonly refetch: any
}

export function ServerSettingsLoader({
  organizationID,
  serverID,
  children
}: {
  readonly organizationID: string
  readonly serverID: string
  readonly children: (props: ChildrenProps) => React.ReactNode
}) {
  return (
    <Query
      query={serverSettingsQuery}
      variables={{ organizationID, serverID }}
      errorPolicy="all"
    >
      {({ data, loading, refetch, ...props }) => {
        if (props.error) {
          throw new Error(props.error)
        }
        const server = data.server
        return children({
          loading,
          server,
          refetch
        })
      }}
    </Query>
  )
}
